module.exports = __webpack_public_path__ + "static/media/man-hip.6f37237b.svg";